import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const demoRegionData = [
    { name: "North", value: 13 },
    { name: "South", value: 22 },
    { name: "East", value: 20 },
    { name: "West", value: 25 },
    { name: "Export", value: 20 },
];

const SHADES_OF_BLACK = ["#10172B", "#404555", "#6F7480", "#9FA2AA", "#CFD0D5"]; // Shades of black

const DonutPieChart = () => {
    return (
        <div className="recent-sales-card">
            <div className="tracking-tight text-sm font-medium">Sales Distribution by Region</div>
            <div className="d-flex justify-content-center">
                <PieChart width={400} height={350}>
                    <Pie
                        data={demoRegionData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        innerRadius={80}
                        outerRadius={120}
                        fill="#8884d8"
                        paddingAngle={5}
                        label={({ name }) => name}
                        labelStyle={{ fill: "black", fontWeight: "bold" }}
                    >
                        {demoRegionData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={SHADES_OF_BLACK[index % SHADES_OF_BLACK.length]} />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend
                        verticalAlign="bottom"
                        height={36}
                        wrapperStyle={{ color: "black", fontWeight: "bold" }}
                    />
                </PieChart>
            </div>
        </div>
    );
};

export default DonutPieChart;
